<script>
const defaultTableOptions = {
  border: true,
  stripe: true,
  size: 'small',
}
const defaultPageOptions = {
  showTotal: true,
  showElevator: true,
  showSize: true,
  size: 'small',
}
export default {
  name: 'Table2',

  data() {
    return {
      tableData: [],
      tableParams: undefined,
      tablePage: undefined,
      tableSort: undefined,
      tableHeight: undefined,
      tableLoading: false,
      currentRow: undefined,
      oldCurrentRow: undefined,
      selection: [],
    }
  },

  props: {
    columns: Array,
    data: Array,
    noPage: Boolean,
    checkbox: Boolean,
    page: {
      type: Object,
      default: () => {
        return {
          pageSize: 20,
          pageNo: 1,
        }
      },
    },
    height: Number,
    query: Function,
    isEqual: Function,
    loadExpand: Function,
    highlightFirst: Boolean,
    immediate: {
      type: Boolean,
      default: true,
    },
    defaultParams: Object,
    defaultSort: {
      type: Object,
      default: () => {
        return {
          sort: 'lastModifyDate',
          order: 'desc',
        }
      },
    },
    pageOptions: Object,
    getTableData: {
      type: Function,
      default: res => res.objList || (Array.isArray(res) ? res : []),
    },
    getTablePage: {
      type: Function,
      default: res => res.pageDesc,
    },
  },

  render(h) {
    const table = h('Table', {
      ref: 'Table',
      class: {
        content: this.height !== undefined,
      },
      props: {
        ...defaultTableOptions,
        columns: this.tableColumns,
        data: this.tableData,
        height: this.tableHeight,
        loading: this.tableLoading,
        // 其他属性
        ...this.$attrs,
      },
      scopedSlots: this.$scopedSlots,
      on: {
        'on-sort-change': res => {
          const column = res.column
          // 前台排序
          if (column.sortable === true) return
          // 后台排序
          this.changeSort(res)
          this.load({ params: this.tableParams })
        },
        'on-current-change': this.changeCurrent,
        'on-selection-change': this.changeSelection,
        'on-expand': (row, status) => {
          if (!status) return
          let index, data
          if (this.isEqual) {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.isEqual(row, this.tableData[i])) {
                index = i
                data = this.tableData[i]
              }
              this.$set(this.tableData[i], '_expanded', false)
            }
          }
          this.$emit('on-expand', data || row, index)
        },
      },
    }, [
      this.$slots.header ? h(this.$slots.header, { slot: 'header' }) : undefined,
    ])

    let page
    if (!this.noPage && this.tablePage) {
      const { totalRows, pageNo, pageSize } = this.tablePage
      page = h('Page', {
        ref: 'Page',
        props: {
          ...defaultPageOptions,
          total: totalRows,
          current: pageNo,
          pageSize,
        },
        on: {
          'on-change': pageNo => {
            this.changePage({ pageNo })
            this.load({ params: this.tableParams })
          },
        },
      })
    }

    return h('div', {
      class: {
        'zpa-table': true,
        'zpa-column': true,
      },
    }, [
      this.$slots.top ? h('div', {
        class: {
          'table-top': true,
          'zpa-row': true,
          'no-fit': true,
          start: true,
        },
      }, [this.$slots.top]) : undefined,
      h('div', {
        ref: 'Container',
        class: {
          'table-container': true,
          'zpa-column': true,
        },
      }, [table]),
      h('div', {
        class: {
          'table-bottom': true,
          'zpa-row': true,
          'no-fit': true,
          end: true,
        },
      }, page ? [page] : undefined),
    ])
  },

  computed: {
    tableColumns() {
      // 特殊Row
      const { expandRow } = this.$scopedSlots
      this.columns.forEach(c => {
        const { key } = c
        if (expandRow && c.type === 'expand') {
          c.render = (h, params) => expandRow(params)
        }
        if (this.$scopedSlots[key]) {
          c.slot = key
        }
      })
      const column = []
      if (this.checkbox) {
        column.push({
          type: 'selection',
          width: 52,
          align: 'center',
        })
      }
      return column.concat(this.columns)
    },
  },

  created() {
    this.tableHeight = this.height
    this.changePage(this.page)
    this.changeSort()
  },

  mounted() {
    if (this.immediate) {
      this.$nextTick(() => this.load())
    }
  },

  methods: {
    async load({ params, page, sort } = {}) {
      this.tableHeight = this.getContainerHeight()
      this.tableParams = Object.assign({}, this.defaultParams, params)
      // 查询参数改变，页数从1开始
      if (params && this._isParamsChange(params)) {
        page = page || {}
        page.pageNo = 1
      }
      if (page) {
        this.changePage(page)
      }
      if (sort) {
        this.changeSort(sort)
      }
      if (!this.data && this.query instanceof Function) {
        this.tableLoading = true
        try {
          const res = await this.query({
            params: this.tableParams,
            page: this.tablePage,
            sort: this.tableSort,
          })
          this.tableData = this.getTableData(res)
          if (this.highlightFirst && this.tableData && this.tableData.length) {
            const row = this.tableData[0]
            row._highlight = true
            this.changeCurrent(row, this.currentRow)
          }
          this.changePage(this.getTablePage(res))
          this.tableLoading = false
        } catch (e) {
          this.tableLoading = false
          this.$Message.error({
            content: e.message,
          })
        }
      }
    },
    changeCurrent(currentRow, oldCurrentRow = this.currentRow) {
      this.currentRow = currentRow
      this.oldCurrentRow = oldCurrentRow
      this.$emit('on-current-change', currentRow, oldCurrentRow)
    },
    changeSelection(selection) {
      this.selection = selection
      this.$emit('on-selection-change', selection)
    },
    changePage(...args) {
      this.tablePage = Object.assign({}, this.tablePage, ...args)
    },
    changeSort({ key, order, column } = {}) {
      column = column || {}
      if (!order || order === 'normal') {
        this.tableSort = Object.assign({}, this.defaultSort)
      } else {
        // sortKey 自定义
        // 没有key的时候一定是slot
        this.tableSort = {
          sort: column.sortKey || key || column.slot,
          order,
        }
      }
    },
    _isParamsChange(params) {
      if (!this._params) {
        this._params = params
        return false
      }
      const propsCurr = Object.getOwnPropertyNames(params)
      const propsCompare = Object.getOwnPropertyNames(this._params)
      if (propsCurr.length !== propsCompare.length) {
        return true
      }
      for (let i = 0, max = propsCurr.length; i < max; i++) {
        const propName = propsCurr[i]
        if (this._params[propName] !== params[propName]) {
          return true
        }
      }
      return false
    },
    getContainerHeight() {
      return this.height || (this.$refs.Container && this.$refs.Container.clientHeight)
    },
  },

  watch: {
    data(data) {
      this.tableLoading = true
      this.tableHeight = this.getContainerHeight()
      try {
        this.tableData = this.getTableData(data)
        if (this.highlightFirst && this.tableData && this.tableData.length) {
          const row = this.tableData[0]
          row._highlight = true
          this.changeCurrent(row, this.currentRow)
        }
        this.$nextTick(() => {
          this.tableLoading = false
        })
      } catch (e) {
        this.tableLoading = false
        this.$Message.error({
          content: e.message,
        })
      }
    },

    page(page) {
      if (page) {
        this.changePage(page)
      }
    },
  },
}
</script>

<style scoped lang="less">
.zpa-table {
  width: 100%;

  .table-top {
    padding-bottom: 8px;
  }

  .table-container {
    overflow: hidden;
  }

  .table-bottom {
    padding-top: 8px;
  }
}
</style>

<style lang="less">
.zpa-table {
  .ivu-table-cell-slot,
  .table-top {
    button {
      margin: 0 4px;
    }
  }
  .ivu-table-tip {
    overflow: hidden;
  }
}
</style>
